import * as yup from "yup";

export const areaSchema = yup.object().shape({
  name: yup.string().required("Esse campo é obrigatório"),
});
